import { Component } from '@opten/compiler/metadata/component';
import { Chart } from 'chart.js';

@Component({ className: 'js-chart' })
export class ChartComponent {
    private readonly CHART_MAX_SCALE = 3;

	private canvas: HTMLCanvasElement;
    private chart: Chart;

    private chartLabels: string[] = [];
    private chartValues: number[] = [];
    private chartMaxValues: number[] = [];

    constructor(private element: HTMLElement) {
        this.chartLabels = this.element.dataset.labels.split(',');
        this.chartValues = this.element.dataset.values.split(',').map(v => parseFloat(v));
        this.chartMaxValues = this.element.dataset.maxValues.split(',').map(v => parseFloat(v));

        let normalizedValues = this.normalizeData(this.chartValues, this.chartMaxValues);
        
        this.canvas = this.element.querySelector('.js-chart-canvas');
        this.chart = new Chart(this.canvas, {
            type: 'radar',
            data: {
                labels: this.chartLabels,
                datasets: [{
                    data: normalizedValues,
                    fill: true,
                    backgroundColor: 'rgba(97, 198, 193, 0.5)',
                    
                    borderColor: 'rgb(164, 164, 164)',
                    pointBackgroundColor: 'rgb(164, 164, 164)',
                    pointBorderColor: 'rgb(164, 164, 164)',
                    borderWidth: 1,
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                font: {
                    family: '\'Barlow\', Arial, Verdana, Georgia, serif',
                    size: 18,
                },
                scales: {
                    r: {
                        beginAtZero: true,
                        min: 0,
                        max: this.CHART_MAX_SCALE,
                        ticks: {
                            display: false,
                            stepSize: 1,
                        }
                    }
                }
            }
        })
	}

    private normalizeData(values: number[], maxValues: number[]): number[] {
        return values.map((val, index) => {
            let normalized = val / maxValues[index];
            return normalized * this.CHART_MAX_SCALE;
        });
    }

}
